import { combineReducers } from 'redux';
import BillingConstants from 'app/shared/constants/BillingConstants';
import invoice from './invoice';
import invoiceList from './invoiceList';
import download from './download';
import payment from './payment';
import paymentMethods from './paymentMethods';
import accountPaymentMethods from './accountPaymentMethods';
import userSettings from './userSettings';

const rootBillingReducer = combineReducers({
    invoice,
    invoicesDue: invoiceList(BillingConstants.INVOICES_DUE),
    invoicesPaid: invoiceList(BillingConstants.INVOICES_PAID),
    download,
    payment,
    paymentMethods,
    accountPaymentMethods,
    userSettings,
});

export default rootBillingReducer;
